<template>
  
  <div class="main-template">
    <card-custom
      class="d-flex flex-column mb-2"
      event_name="pvsystInput"
      :show_dropdown_state="true"
      :dropdown_state="cardMessage.pvsystInput"
      outlined
      elevation="1"
      style="width: 100%;"
    >

      <template v-slot:title>
        <div class="text-subtitle-2">{{ $t("_saisie_de_ hypotheses_de_dimensionnement_(ex_PVSYST)_") }}</div>
      </template>

      <template v-slot:content>
        <v-container class="d-flex flex-column px-0 py-0" v-html="$t('_pvsyst_saisi_des_donnees_texte_explicatif_') ">
 
        </v-container>
      </template>
    </card-custom>


    <v-card class="input-file">
      <v-file-input
        accept=".xlsx"
        :label='$t("_importer_des_donnees_pvsyst_(optionnel)_(xlsx)_")'
        v-model= file
        @change="importXlsx()"
      />
    </v-card>

    <div v-for="item in inputData" :key="item.name" >
      <v-text-field
        v-if="!item.name.includes('input_client') && item.unit && item.name !== 'pvsyst_AC_energy_meter'"  
        :label="$t(item.label) + ' (' + item.unit+ ')'"  
        v-model.number="item.value" type="number" 
        step="0.00001" 
        required 
        clearable
        dense
         @change="saveInputDataStore"/>
      <v-text-field
        v-else-if="!item.name.includes('input_client') && item.name !== 'pvsyst_AC_energy_meter' "  
        :label="$t(item.label)"  
        v-model.number="item.value" type="number" 
        step="0.00001" 
        required 
        clearable
        dense
         @change="saveInputDataStore"/>
      <br>
    </div>
  </div>
</template>

<script>
import api from '@/api/api'
import CardCustom from "../UI_kit/CardCustom.vue"
import eventBus from "../../store/event_bus"

export default{
  name: "PvsystInput",

  components: {
    CardCustom
  },

  watch:{
    '$store.getters.globalIncline' : {
      async handler() {
        this.setGlobalIncline(this.$store.getters.globalIncline)
        await this.runCalculate()
      },
      immediate: false,
     },


    '$store.getters.energieCompteurAC' : {
      async handler() {
        this.setEnergieCompteurAC(this.$store.getters.energieCompteurAC)
        await this.runCalculate()
      },
      immediate: false,
     },
     async '$store.getters.niv2CalendarRefresh'() {
      if (this.$store.getters.niv2CalendarRefresh) {
        this.$store.commit('SET_NIV2_CALENDAR_REFRESH', false)
        
      }
     },
     
  },

  mounted (){
    this.filedTable()

    eventBus
      .$on(`card_custom`, (obj) => {
        this.cardMessage[obj.component] = obj.state
      })
  },

  beforeDestroy() {
    eventBus.$off(`card_custom`)
  },

  data:function() {
    return{
      items: [],
      sendingValues: {"input":[]},
      tab: 'one',
      val: 0,
      file: null,
      start_date: null,
      end_date: null,
      cardMessage: {
        "pvsystInput": true,
      }
    }
  },

  computed: {
    inputData: function() {
      /**
       * Get all input values
       */
      return this.items.filter(i => i.name.includes('pvsyst'))
    },

    auditDates() {
			return this.$store.state.audit_dates
		},
    dates() {
        return this.$store.state.parametersStore.dates
    },
  },


  methods: {
    filedTable(){
      /**
       * filed table with input values and calculate values
       */
      this.setValues()
      if (this.$store.getters.inputData){
        let item_bis = this.$store.getters.inputData
        for (let item in this.items){
          let elem = item_bis.find((element) => element.name === this.items[item].name)
          if (elem != null ){
            this.items[item]["value"] = elem.value
          } else {
            this.items[item]["value"] = null
          }
        }
      }
      this.$forceUpdate();
      return true
    },

    async runCalculate(){
      /*
        Run calculate with input values
      */
      let data = false
      this.formatSendingDatas()
     
      if (this.$store.getters.expertDates.start && this.$store.getters.expertDates.end) {  
        this.start_date=this.$store.getters.expertDates.start
        this.end_date=this.$store.getters.expertDates.end
        console.log("1.", this.start_date, this.end_date)
        
      } else {
        this.start_date = this.$store.getters.dates.start,
        this.end_date = this.$store.getters.dates.end,
        console.log("2.",this.start_date, this.end_date)
        
      }
      
      if(this.start_date && this.end_date){
        await api.calculatePvsystValue(
          this.sendingValues,
          this.$route.params.id,
          this.start_date,
          this.end_date
        ).then((res)=>{
          data = res.data
        })

      }
      else{
        alert(this.$t("_les_dates_saisies_ne_sont_pas_valides_"))
      }
     
    

      return data
    },

    saveInputDataStore(){
      /**
       * Save input values in localStorage
       */
      this.$store.dispatch("setInputData",this.inputData)
    },

    setValues(){
      /*
       * Init items with constants file values
       */
      this.items = this.$store.getters.constants['pvsyst'][0]["datas"]

      for (let item in this.items){
        this.items[item].value = null
      }
    },

    formatSendingDatas(){
      /*
       * Format data to API format
       */
      this.sendingValues.input = []
      for (let item in this.inputData){
        this.sendingValues.input.push({
          "name": "#" + this.inputData[item].name + "#",
          "value": this.inputData[item].value
        })
      }
    },

    resetValues(){
      /**
       * reset value by null
       */
      for (let item in this.inputData){
        this.inputData[item].value = null
      }
      this.saveInputDataStore()
      this.$forceUpdate();
    },

    async importXlsx(){
      if (this.file) {
        let result = await api.convertPvsystXlsxToJson(this.file)
        for (let e in result.data){
          let index = this.items.findIndex((element) => element.name === result.data[e].name)
          if (index > -1){
            this.items[index].value = result.data[e].value
          }
        }
        this.saveInputDataStore()
        let index = this.items.findIndex((element) => element.name === "input_client_global_inclined")
        await this.$store.dispatch("setGlobalIncline",this.items[index].value)
        index = this.items.findIndex((element) => element.name === "pvsyst_AC_energy_meter")
        await this.$store.dispatch("setEnergieCompteurAC",this.items[index].value)
        this.$forceUpdate();
      }

    },

    setEnergieCompteurAC(value){
      /**
       * set compter energie ac when the value change in other component
       */
       const found = this.inputData.findIndex((element) => element.name === "pvsyst_AC_energy_meter")
      if (found == null || found < 0) {
        this.inputData.push({
            "name": "pvsyst_AC_energy_meter",
            "value": value,
            "label": "_global_incline_mesurer_",
            "unit": "MWh",
            "section": "output_losses_9",
            "positions": []
          })
      } else {
        this.inputData[found].value = value
      }
      this.saveInputDataStore()
      this.runCalculate().then(()=>{
        this.$forceUpdate();
      })
    },

    setGlobalIncline(value){
      /**
       * set global incline when the value change in other component
       */
      const found = this.inputData.findIndex((element) => element.name === "input_client_global_inclined")
      if (found == null || found < 0) {
        this.inputData.push({
            "name": "input_client_global_inclined",
            "value": value,
            "label": "_global_incline_mesurer_",
            "unit": "kWh/m2",
            "section": "output_losses_1",
            "positions": [
              {
                "line": "_global_incline_",
                "column": "pvsyst_act_autre_meteo"
              },
              {
                "line": "_global_incline_",
                "column": "heliocity_autre_meteo"
              }
            ]
          })
      } else {
        this.inputData[found].value = value
      }
      this.saveInputDataStore()
      this.runCalculate().then(()=>{
        this.$forceUpdate();
      })
    }
  }
}
</script>

<style scoped>
  .main-template{
    margin-left:20%;
    margin-right:20%;
    margin-top:1%
  }

  .input-file{
    margin-bottom: 50px;
    padding-left: 10px;
    padding-top: 10px;
    padding-right: 20px;
  }
</style>
